import { LogLevel, IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, InteractionType } from '@azure/msal-browser';
import { MsalInterceptorConfiguration, MsalGuardConfiguration } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  if (!environment.msalConfigB2C.loggingEnabled) {
    return;
  }

  switch (logLevel) {
    case LogLevel.Error:
      console.error(message);
      break;
    case LogLevel.Warning:
      console.warn(message);
      break;
    case LogLevel.Info:
      console.info(message);
      break;
    case LogLevel.Verbose:
      console.debug(message);
      break;
  }
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfigB2C.clientId,
      authority: environment.msalConfigB2C.authority,
      redirectUri: environment.msalConfigB2C.redirectUri,
      navigateToLoginRequestUrl: environment.msalConfigB2C.navigateToLoginRequestUrl,
      postLogoutRedirectUri: environment.msalConfigB2C.postLogoutRedirectUri,
      knownAuthorities: environment.msalConfigB2C.knownAuthorities
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE // set to true for IE 11
    },
    // Turn this on in Dev for debugging
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: environment.msalConfigB2C.logLevel,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.traxFtlApiServerUrl, environment.msalConfigB2C.scopes);
  protectedResourceMap.set(environment.traxApiServerUrl, environment.msalConfigB2C.scopes);
  protectedResourceMap.set(environment.calendarApiServerUrl, environment.msalConfigB2C.scopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    authRequest: (msalService, httpReq, originalAuthRequest) => {
      return {
        ...originalAuthRequest,
        authority: environment.msalConfigB2C.authority
      }
    }
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.msalConfigB2C.scopes,
      authority: environment.msalConfigB2C.authority
    }
  };
}
